<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <v-card outlined class="pa-6 mb-6 elevation-0">
      <GradeReportFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <GradeReportTable :query="query" :subjects="subjects" :room="room" :exam="exam" />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import GradeReportFilter from './GradeReportFilter.vue'
import GradeReportTable from './GradeReportTable.vue'

export default {
  components: {
    StudentBlankView,
    GradeReportFilter,
    GradeReportTable
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subjects: [],
      room: {},
      query: {},
      exam: {},
      type: null,
      grade: null
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, exam) {
      this.action.state = 'filtered'
      this.query = params
      this.exam = exam
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
